import styled, {css} from 'styled-components';
import {dFlexColumnCenter, dFlexCenter, dFlex, alignCenter} from '../../../../globalVariables/GlobalFlex';
import {ellipsisLines} from '../../../../globalVariables/GlobalVariables';

export const body = styled.div`
    flex: 1;
    width: 100%;
    ${dFlexColumnCenter};
    gap: var(--space-xl);
    padding: var(--space-md) 0;
`;

export const title = styled.h3`
    font-size: var(--font-size-heading-modal);
    font-weight: var(--font-weight-bold);
    line-height: 1.2;
    text-align: center;
    word-break: break-word;
    margin-inline: var(--space-lg);
`;

export const ticketName = styled.div<{$accessible?: boolean}>`
    align-self: stretch;
    margin-inline: var(--space-lg);
    background: var(--color-bg-surface-default);
    padding: var(--space-sm) var(--space-md);
    border-radius: var(--border-radius-border-radius-lg);
    font-size: var(--font-size-body-small);
    line-height: 1.3;
    text-align: center;
    ${p => p.$accessible && css`
        ${dFlex}
        ${alignCenter}
        gap: var(--space-sm);
        text-align: start;
    `}
`;

export const a11yIcon = styled.span`
    flex: none;
    width: 24px;
    height: 24px;
    border-radius: var(--border-radius-border-radius-full);
    background: var(--color-blue-600);
    ${dFlexCenter}

    svg {
        width: 14px;
        height: 14px;
    }
`;

export const ticketNameText = styled.span`
    ${ellipsisLines(2)}
`;

export const ticketNo = styled.div`
    font-size: var(--font-size-caption);
    font-weight: var(--font-weight-regular);
    color: var(--color-text-subtle);
    text-align: center;
`;
